import React from 'react';
import './App.css';
import Header from './Header';
import 'bootstrap/dist/css/bootstrap.min.css';
import Imagebox from './Imagebox';


function App() {
  return (
    <div className="App">
      <Header/>
      <Imagebox/>
    </div>
  );
}

export default App;
